import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import LogoMS from "../../../../assets/images/logo_ms.gov.br.svg";
import { items } from "./items";
import { useSidebarStyles } from "./styles";
import { usePermission } from "../../../../hooks/usePermission";
import { useAuth } from "../../../../contexts/auth";

export default function Sidebar() {
    const { pathname } = useLocation();
    const { canAccess } = usePermission();
    const { isAdminUserLoading, adminUser } = useAuth();
    const [collapsed, setCollapsed] = useState(false);
    const [delayedCollapsed, setDelayedCollapsed] = useState(false);
    const { classes } = useSidebarStyles({ collapsed });

    useEffect(() => {
        if (collapsed) {
            setDelayedCollapsed(true);
            return;
        }
        const timer = setTimeout(() => setDelayedCollapsed(false), 160);
        return () => clearTimeout(timer);
    }, [collapsed]);

    const handleToggle = () => setCollapsed((prev) => !prev);

    function checkItemIsActive(path: string) {
        return pathname.includes(path);
    }

    if (isAdminUserLoading) {
        return (
            <Grid item className={classes.root}>
                <Box className={classes.header}>
                    <IconButton
                        classes={{ root: classes.menuButton }}
                        onClick={handleToggle}
                        disableRipple
                    >
                        <Menu htmlColor="#FFF" />
                    </IconButton>
                </Box>
                <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                    <CircularProgress style={{ color: "#FFF" }} />
                </Box>
            </Grid>
        );
    }

    return (
        <Grid item className={classes.root}>
            <Box className={classes.header}>
                {!collapsed && (
                    <img src={LogoMS} alt="Logo do MS" className={classes.logo} />
                )}
                <IconButton
                    classes={{ root: classes.menuButton }}
                    onClick={handleToggle}
                    disableRipple
                >
                    <Menu htmlColor="#FFF" />
                </IconButton>
            </Box>
            <List
                component="nav"
                className={classes.list}
                aria-label="main mailbox folders"
            >
                {items.map((item, idx) => {
                    const shouldShow = item.href === "/prioridades" 
                        ? adminUser?.permissions?.includes("Administrador de Atendimento")
                        : canAccess(item.allowedRoles);
                    
                    return shouldShow && (
                        <ListItem
                            button
                            key={`sidebar-item-${idx}`}
                            component={Link}
                            to={item.href}
                            classes={{ root: classes.listItem }}
                            style={{
                                backgroundColor: checkItemIsActive(item.href)
                                    ? "#073A78"
                                    : "transparent",
                            }}
                        >
                            <ListItemIcon className={classes.listItemIcon}>
                                <item.icon htmlColor="#FFF" />
                            </ListItemIcon>
                            {!delayedCollapsed && (
                                <ListItemText
                                    primaryTypographyProps={{ style: { fontWeight: "normal" } }}
                                    primary={item.label}
                                />
                            )}
                        </ListItem>
                    );
                })}
            </List>
        </Grid>
    );
}
